import { ImsSettingsUpdateSchema } from "@redotech/redo-inventory-common/ims-settings";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateImsSettings = {
  name: "updateImsSettings" as const,
  input: z.object({
    teamId: zExt.objectId(),
    settings: ImsSettingsUpdateSchema,
  }),
  output: z.object({}),
};
